import {
  UpdatedStyledConditionBadge,
  UpdatedQueryBuilderFollowingText,
  UpdatedQueryBuilderLeadText,
} from 'modules/predictiveGoals/components/queryBuilder/components/pgQueryBuilderEnhancements/styles';
import { BADGE_VARIANTS } from 'ui/badge';
import { CONDITIONAL_TEXT } from 'modules/predictiveGoals/components/queryBuilder/constants';
import {
  EVENT_OR_PROPERTY_LEADING_TEXT,
  EVENT_OR_PROPERTY_TRAILING_TEXT,
} from 'modules/predictiveGoals/constants';

type OrConditionalBlockProps = {
  index: number;
  type: 'event' | 'property';
};

export const UpdatedOrConditionalBlock = ({ index, type }: OrConditionalBlockProps) => {
  if (index === 0) {
    return (
      <UpdatedQueryBuilderLeadText>
        {EVENT_OR_PROPERTY_LEADING_TEXT[type]}
      </UpdatedQueryBuilderLeadText>
    );
  } else {
    return (
      <UpdatedQueryBuilderFollowingText>
        <UpdatedStyledConditionBadge variant={BADGE_VARIANTS.READY}>
          {CONDITIONAL_TEXT.or.toUpperCase()}
        </UpdatedStyledConditionBadge>
        <div> {EVENT_OR_PROPERTY_TRAILING_TEXT[type]}</div>
      </UpdatedQueryBuilderFollowingText>
    );
  }
};
